import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';
import { environment } from 'src/environments/environment';
import { StandardUIService } from '../services/standardui-service/standardui-service';

@Component({
  selector: 'app-newgrid',
  templateUrl: './newgrid.component.html',
  styleUrls: ['./newgrid.component.scss']
})
export class NewgridComponent {
  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();
  @Input() serviceTypeInfo: any;
  @Input() viewType: any; 
   @Output() dataInformation=new EventEmitter();


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  serviceTypeSearch: any = '';
  selectedServiceType: any = {};
  selectedDepartmentTypes: any = {};
  selectedCasetypedata:any=[]
  activecasetype:any
  activedepid:any
  activecasetypeid:any
  activecasesubtypeid:any
  testdata:any=[]
  searchService: any;
  departmentItems: any = [];
  dataSource: MatTableDataSource<any>;
  displayedColumnsGrid: string[] = ['id', 'content', 'actions'];
  tab_title:any
  newdepartmentItems:any=[]
  ngOnInit() {
    this.dataInformation.emit();

    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')
    var filtereddepartment='false'
    this.stnadardUiService.castuserDetails.subscribe((data)=>{
      if(data){
        console.log(data); 
        // console.log(data.roles[0].authority)
        if(data.roles && data.roles[0]?.authority)
        {
          filtereddepartment=data.roles[0]?.authority.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
        }

        

    // this.http.get<any>('/assets/json/dataArray.json').subscribe((data) => {
      this.http.get<any>(environment.apiURL + 'getDeptcasedefToAgent').subscribe((data) => {
      this.departmentItems = data;

      this.departmentItems.sort((a: { content: string; }, b: { content: string; }) => {
        const contentA = a.content.toLowerCase();
        const contentB = b.content.toLowerCase();
    
        if (contentA < contentB) return -1;
        if (contentA > contentB) return 1;
        return 0;
    });

    if (filtereddepartment!='false' && filtereddepartment.includes('parkingcontrol')) { 
     $('body').addClass('parkingcontrolui');
      this.departmentItems = this.departmentItems.filter(item =>
        item.content.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().includes(filtereddepartment)
      );
    }

      this.newdepartmentItems=[...this.departmentItems]
      
      // this.departmentDataSource = new MatTableDataSource(this.departmentItems);
      // console.log(this.departmentDataSource)
      // this.casetypeDataSource = new MatTableDataSource(this.departmentItems.caseType);
      // if (this.serviceTypeInfo && this.serviceTypeInfo.serviceDetails && this.serviceTypeInfo.serviceDetails.caseType || this.serviceTypeInfo  && this.serviceTypeInfo.caseType) {
      //   this.selectedDepartmentTypes = this.serviceTypeInfo?this.serviceTypeInfo:this.serviceTypeInfo;
      //   if(this.serviceTypeInfo){
      //     // let serviceDetails = {
      //     //   serviceDetails:this.serviceTyp eInfo.serviceDetails
      //     // }
      //     // this.serviceTypeInfo = serviceDetails;
      //   }
      //   // this.getCaseType(this.serviceTypeInfo.serviceDetails)
      // }else if(this.departmentItems && this.departmentItems.length){
        // var selecteddep=this.agentscriptService.fetchData(this.tab_title, 'selecteddepartment')
        // // console.log(selecteddep)
        // if(selecteddep!=0)
        //   {
        //     // console.log(selecteddep)
        //     this.selectedServiceType = selecteddep;
        //     this.selectedDepartmentTypes = selecteddep;
        //   }
        //   else
        //   {
        //     selecteddep=this.departmentItems[0]
        //   }
        // this.getCaseType(selecteddep);

        var casetypedata_fetched=this.agentscriptService.fetchData(this.tab_title, 'casetypedata')
      if(casetypedata_fetched!=0)
        {
          // casetypedata=casetypedata.serviceDetails
          this.selectedCasetypedata=casetypedata_fetched.serviceDetails
          var kk:any=[]
          kk=casetypedata_fetched.serviceDetails
          this.testdata=kk
          this.activecasetype=this.agentscriptService.fetchData(this.tab_title, 'casetypedata').serviceDetails
          console.log(this.activecasetype)
          this.activecasetypeid=this.activecasetype.casetypeid
          this.activedepid=this.activecasetype.department.id
          this.activecasesubtypeid=this.activecasetype?.casesubtypeid
          this.selectedDepartmentTypes=[]
          var deptselected=this.departmentItems.find((item:any)=>item.caseType[0].department.id == this.selectedCasetypedata?.department.id)
          this.getCaseType(deptselected);
          // this.selectedDepartmentTypes=casetypedata_fetched.serviceDetails
          // console.log(this.selectedDepartmentTypes)
          // console.log(this.selectedDepartmentTypes.casetypeid)
          
        }
        else
        {
          this.getCaseType(this.departmentItems[0]);
        }
      // }
    });
      }
    })
    // this.testdata=[]
    
  }

  selectedcasetypeactive(item)
  {
    // console.log(item)
    // console.log(this.activecasetype)
    // console.log(this.selectedCasetypedata)
    // console.log(item.casetypeid == this.selectedCasetypedata?.casetypeid)
    // console.log(item.department.id)
        if(item.casetypeid == this.activecasetypeid && item.department.id == this.activedepid && ((item?.casesubtypeid && this.activecasesubtypeid)?item.casesubtypeid == this.activecasesubtypeid:true))
          {
    //         console.log(item)
    // console.log(this.activecasetype)
    
          return true
          }
      
      return false
  }

  selecteddepartmentactive(item)
  {
    // console.log(this.selectedDepartmentTypes)
    if(item?.caseType[0]?.department?.id == this.selectedCasetypedata?.department.id)
      {
        return true
      }
    else if(this.selectedDepartmentTypes.id == item.id )
      {
        return true
      }
      return false;
  }

  clearsearch()
  {
    this.searchterms=""
    // this.agentscriptService.updateOrInsertArray(this.tab_title,'searchterms','')
    this.departmentItems=[...this.newdepartmentItems]
  }
  clearcasetypesearch()
  {
    this.searchcasetypes=''
    this.casetypedata=[...this.newcasetypedata]
  }


  ngOnChanges(changes: SimpleChanges) {
    // this.setListView();
  }
  isTooltipVisible = false;

  showTooltip() {
    this.isTooltipVisible = true;
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }
  setListView(){
    if(this.selectedDepartmentTypes && this.selectedDepartmentTypes.caseType){
      this.dataSource = new MatTableDataSource(this.selectedDepartmentTypes.caseType);
    }else{
      this.dataSource = new MatTableDataSource([]);
    }
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
     })

  }
  gotoNext(data: any) {
    this.selectedDepartmentTypes=data.item
    // let serviceDetails = data.serviceDetails;
    // this.selectedServiceType["serviceDetails"] = serviceDetails;
    // this.selectedDepartmentTypes = serviceDetails;
    // data.serviceDetails['caseType'] = this.casetypeDataSource.filteredData;

    // console.log(data.serviceDetails)
    this.agentscriptService.addtorecentservices(data.serviceDetails).subscribe((response)=>
      {
        console.log(response)
      })
    // this.agentscriptService.updateOrInsertArray(this.tab_title,'casetypedata',data.serviceDetails)
    // console.log(this.agentscriptService.fetchData(this.tab_title,'casetypedata'))
    // console.log(data)

    this.agentscriptService.updateOrInsertArray(this.tab_title, 'modifiedfromanonymouscontact',0)

    this.serviceTypeDetailsOutputEvent.emit(data)
  }
  displayedColumns: string[] = ['id', 'content','actions'];
  caseTypeCard: Boolean = false;
  showdept:boolean=true;
  // departmentDataSource = new MatTableDataSource(this.departmentItems);
  // casetypeDataSource = new MatTableDataSource(this.departmentItems.caseType);
  casetypedata:any=[]
  newcasetypedata:any=[]
  constructor(private http: HttpClient,private agentscriptService:AgentscriptService_updated,private stnadardUiService:StandardUIService) {}
  getCaseType(item: any) {
    console.log(item)
    this.searchcasetypes=''
    this.selectedCasetypedata.department=item?.caseType[0].department
    this.selectedDepartmentTypes=item
    // this.agentscriptService.selected
    // console.log(item)
    // var selecteddep=this.agentscriptService.fetchData(this.tab_title, 'selecteddepartment')
    // console.log(selecteddep)
    // if(selecteddep!=0)
    //   {
    //     item=selecteddep
    //     console.log(item)
    //   }
    this.agentscriptService.updateOrInsertArray(this.tab_title, 'selecteddepartment', item)
    // console.log(item)
    this.selectedServiceType = item;
    // this.selectedDepartmentTypes = item;
    this.serviceTypeSearch = "";
    this.caseTypeCard = true;
    // console.log(item)
    // this.casetypeDataSource = (item.caseType.length) ? new MatTableDataSource(item.caseType) : new MatTableDataSource(this.departmentItems.caseType);
    this.casetypedata=(item.caseType.length) ?item.caseType : this.departmentItems.caseType;
  //   this.casetypedata.sort((a: { content: string; }, b: { content: string; }) => {
  //     const contentA = a.content.toLowerCase();
  //     const contentB = b.content.toLowerCase();
  
  //     if (contentA < contentB) return -1;
  //     if (contentA > contentB) return 1;
  //     return 0;
  // });

  this.casetypedata.sort((a: { content: string; casetypeid: number; }, b: { content: string; casetypeid: number; }) => {
    const specialCasetypeId = 296;
    
    // Check if a or b has the special department id
    if (a.casetypeid === specialCasetypeId) return 1;
    if (b.casetypeid === specialCasetypeId) return -1;
  
    // Regular alphabetical sorting
    const contentA = a.content.toLowerCase();
    const contentB = b.content.toLowerCase();
    
    if (contentA < contentB) return -1;
    if (contentA > contentB) return 1;
    return 0;
  });


  this.newcasetypedata=[...this.casetypedata]
    // console.log(this.casetypeDataSource)
    this.showdept=false;
    this.setListView();
  }
  showdepartment()
  {
    this.showdept=true;
  }
  searchterms:any='';
  searchcasetypes:any=''
  applyFilter(event: any) {
    this.departmentItems=[...this.newdepartmentItems]
    this.departmentItems = this.departmentItems.filter((x: any) => {
      const searchTerm = this.searchterms.toLowerCase(); // Convert to lowercase for case-insensitive check
      const contentIncludesTerm = x.content.toLowerCase().includes(searchTerm);
      const divisionIncludesTerm = x.caseType[0].division.name.toLowerCase().includes(searchTerm);
  
      // console.log('Search Term:', searchTerm);
      // console.log('Content Includes Term:', contentIncludesTerm);
      // console.log('Division Includes Term:', divisionIncludesTerm);
  
      return contentIncludesTerm || divisionIncludesTerm;
  });
    // console.log(this.searchterms)
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.departmentDataSource.filter = filterValue.trim().toLowerCase();
    // this.casetypeDataSource.filter = filterValue.trim().toLowerCase();
  }
  applycasetypeFilter(event: any) {
    this.casetypedata=[...this.newcasetypedata]
    this.casetypedata = this.casetypedata.filter((x: any) => {
      const searchTerm = this.searchcasetypes.toLowerCase(); // Convert to lowercase for case-insensitive check
      const contentIncludesTerm = x.content.toLowerCase().includes(searchTerm);
      return contentIncludesTerm 
  });
    // console.log(this.searchcasetypes)
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.departmentDataSource.filter = filterValue.trim().toLowerCase();
    // this.casetypeDataSource.filter = filterValue.trim().toLowerCase();
  }
  back() {
    this.caseTypeCard = false;
  }
  onEnter(event: any) {
    const filterValue = event.option.value;
    // this.departmentDataSource.filter = filterValue.trim().toLowerCase();
    // this.casetypeDataSource.filter = filterValue.trim().toLowerCase();
  }
  onDeptEnter(event: any) {
    const filterValue = event.option.value;
    // this.departmentDataSource.filter = filterValue.trim().toLowerCase();
    // this.casetypeDataSource.filter = filterValue.trim().toLowerCase();
  }
}

